/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventId } from "../../commons/types/EventId";
export const DetailedAgentLog = core.serialization.object({
    eventId: EventId,
    success: core.serialization.boolean(),
    createdAt: core.serialization.date(),
    completedAt: core.serialization.date(),
    duration: core.serialization.number(),
    topic: core.serialization.string(),
    context: core.serialization.record(core.serialization.string(), core.serialization.any()),
    log: core.serialization.string().optional(),
});
